module.exports = __webpack_public_path__ + "img/pipe-smoking.7e69f2de.svg";